<template>
<div class="viskase-layout">
    <header class="viskase-header" id="viskase-header">
        <viskase-app-header />
    </header>
    <div class="viskase-content" id="viskase-content" v-on:scroll="handleScroll">
        <div class="container h-100">
            <div :class="layout(viewName)" class="row h-100">
                <router-view></router-view>
            </div>
        </div>
    </div>
    <div class="viskase-footer" id="viskase-footer">
        <viskase-app-footer />
    </div>
    <div :class="{show: show}" @click="scrollToTop()" class="viskase-to-top" id="viskase-to-top">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="white" class="bi bi-chevron-up" viewBox="0 0 16 12">
            <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"></path>
        </svg>
    </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ViskaseAppFooter from "./components/core/ViskaseAppFooter.vue";
import ViskaseAppHeader from "./components/core/ViskaseAppHeader.vue";
export default {
  components: {
    ViskaseAppHeader,
    ViskaseAppFooter,
  },
  data() {
    return {
      show: false,
    };
  },
  mounted() {
    this.fetchLanguages();
    this.emitter.on("scroll-to-top", () => {
      const viskaseContent = document.querySelector("#viskase-content");
      viskaseContent.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  },
  computed: {
    ...mapGetters(["layout"]),
    viewName() {
      return this.$route.name;
    },
  },
  methods: {
    ...mapActions(["fetchLanguages"]),
    scrollToTop() {
      this.emitter.emit("scroll-to-top");
    },
    handleScroll() {
      const viskaseContent = document.querySelector("#viskase-content");
      this.show = viskaseContent.scrollTop > 100;
    },
  },
};
</script>

<style lang="scss">
@import "./public/assets/scss/style.scss";

html,
body {
  margin: 0;
  height: 100%;
  /* can also use viewport units (height: 100vh) */
}

body {
  // display: flex;
  //overflow: hidden;
  //overflow-y: scroll;
  -webkit-text-size-adjust: none;
  touch-action: pan-y;
}

#app {
  font-family: "Mulish", century-gothic, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  //flex: 1;
  margin: 3 rem;
  height: 100%;
  //width: 100%;
  //display: flex;
}

.viskase-layout {
  display: flex;
  flex-direction: column;
  padding: 0.25rem !important;
  //box-sizing: border-box;
  //height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  //min-height: 100%;
  //background-color: rgb(119, 100, 100);
  //font-size: 1.3em;
}

.viskase-header {
  background-color: #ffffff;
  flex: 0 0 auto;
}

.viskase-content {
  flex: 1 1 auto;
  //max-height: 100%;
  overflow-x: hidden;
  //height: 100%;
  overflow-y: auto;
}

.viskase-footer {
  background-color: #ffffff;
  flex: 0 0 auto;
}

// @media only screen and (min-width: 480px) and (max-width: 767px) {
// }

// @media screen and (min-aspect-ratio: 13/9) {
//   .col-xsl-6 {
//     width: 50%;
//   }
// }

// // landscape and
// @media screen and (max-aspect-ratio: 13/9) {
//   .col-xsl-6 {
//     width: 50%;
//   }
// }

// portrait.

.casing-title {
  color: brown;
  font-weight: 900;
}

.col-1by5,
.col-xs-1by5,
.col-sm-1by5,
.col-lg-1by5 {
  position: relative;
  min-height: 1px;
  padding: 1px;
  width: 20%;
  float: left;
}

.col-2by5,
.col-xs-2by5,
.col-sm-2by5,
.col-lg-2by5 {
  position: relative;
  min-height: 1px;
  padding: 1px;
  width: 40%;
  float: left;
}

.col-3by5,
.col-xs-3by5,
.col-sm-3by5,
.col-lg-3by5 {
  position: relative;
  min-height: 1px;
  padding: 1px;
  width: 60%;
  float: left;
}

.col-4by5,
.col-xs-4by5,
.col-sm-4by5,
.col-lg-4by5 {
  position: relative;
  min-height: 1px;
  padding: 1px;
  width: 80%;
  float: left;
}

.col-5by5,
.col-xs-5by5,
.col-sm-5by5,
.col-lg-5by5 {
  position: relative;
  min-height: 1px;
  padding: 1px;
  width: 100%;
  float: left;
}

.col-1by8,
.col-xs-1by8,
.col-sm-1by8,
.col-md-1by8,
.col-lg-1by8,
.col-xl-1by8,
.col-xxl-1by8 {
  position: relative;
  min-height: 1px;
  padding: 1px;
  width: 12.5%;
  float: left;
}

.col-2by8,
.col-xs-2by8,
.col-sm-2by8,
.col-md-2by8,
.col-lg-2by8,
.col-xl-2by8,
.col-xxl-2by8 {
  position: relative;
  min-height: 1px;
  padding: 1px;
  width: 25%;
  float: left;
}

.col-3by8,
.col-xs-3by8,
.col-sm-3by8,
.col-md-3by8,
.col-lg-3by8,
.col-xl-3by8,
.col-xxl-3by8 {
  position: relative;
  min-height: 1px;
  padding: 1px;
  width: 37.5%;
  float: left;
}

.col-4by8,
.col-xs-4by8,
.col-sm-4by8,
.col-md-4by8,
.col-lg-4by8,
.col-xl-4by8,
.col-xxl-4by8 {
  position: relative;
  min-height: 1px;
  padding: 1px;
  width: 50%;
  float: left;
}

.col-5by8,
.col-xs-5by8,
.col-sm-5by8,
.col-md-5by8,
.col-lg-5by8,
.col-xl-5by8,
.col-xxl-5by8 {
  position: relative;
  min-height: 1px;
  padding: 1px;
  width: 62.5%;
  float: left;
}

.col-6by8,
.col-xs-6by8,
.col-sm-6by8,
.col-md-6by8,
.col-lg-6by8,
.col-xl-6by8,
.col-xxl-6by8 {
  position: relative;
  min-height: 1px;
  padding: 1px;
  width: 75%;
  float: left;
}

.col-7by8,
.col-xs-7by8,
.col-sm-7by8,
.col-md-7by8,
.col-lg-7by8,
.col-xl-7by8,
.col-xxl-7by8 {
  position: relative;
  min-height: 1px;
  padding: 1px;
  width: 87.5%;
  float: left;
}

.col-8by8,
.col-xs-8by8,
.col-sm-8by8,
.col-md-8by8,
.col-lg-8by8,
.col-xl-8by8,
.col-xxl-8by8 {
  position: relative;
  min-height: 1px;
  padding: 1px;
  width: 100%;
  float: left;
}

.btn-viskase-white-slim {
  background-color: #fff;
  color: #a0273b !important;
  border-radius: 0;
  border: 1px solid #a0273b;
}

.btn-viskase-orange-slim {
  background-color: #a0273b;
  color: #fff !important;
  border-radius: 0;
  border: 1px solid #a0273b;
}

.btn-viskase-orange {
  background-color: #a0273b;
  color: #fff !important;
  border-radius: 0;
  border: 1px solid #a0273b;
}

.btn-viskase-white {
  background-color: #fff;
  color: #a0273b !important;
  border-radius: 0;
  border: 1px solid #a0273b;
}

.btn-viskase {
  background-color: #a0273b;
  color: #fff !important;
  min-height: 1.5rem;
  min-width: 100%;
  border-radius: 0;
}

@media (min-width: 0px) and (max-width: 767px) {
  #app {
    font-size: 12px;
  }

  .footer-row > * {
    padding-right: calc(var(--bs-gutter-x) * 0.25) !important;
    padding-left: calc(var(--bs-gutter-x) * 0.25) !important;
  }

  .h4 {
    font-size: calc(1.1rem + 0.1vw);
  }

  .btn-viskase-white-slim {
    font-size: 0.7rem;
    width: 100%;
    padding: 0.2rem 0.2rem;
  }

  .btn-viskase-orange-slim {
    font-size: 0.7rem;
    width: 100%;
    padding: 0.2rem 0.2rem;
  }

  .btn-viskase-orange {
    min-height: 1.25rem;
    //width: 100%;
    padding: 0.2rem;
    margin: 0.1rem;
    font-size: 0.7rem;
  }

  .btn-viskase-white {
    min-height: 1.25rem;
    //width: 100%;
    padding: 0.2rem;
    margin: 0.1rem;
    font-size: 0.7rem;
  }

  .btn-viskase-sm-wide {
    font-size: 0.7rem;
    width: 100%;
    padding: 0.2rem;
  }

  .btn-viskase {
    min-height: 2.25rem;
    font-size: 0.7rem;
    padding: 0.2rem;
  }

  .font-size-xs-4 {
    font-size: 0.4rem;
  }

  .font-size-xs-6 {
    font-size: 0.6rem;
  }
}

@media (min-width: 0px) {
  .offset-1by5 {
    margin-left: 20%;
  }

  .offset-2by5 {
    margin-left: 40%;
  }

  .offset-3by5 {
    margin-left: 60%;
  }

  .offset-4by5 {
    margin-left: 80%;
  }

  .offset-5by {
    margin-left: 100%;
  }

  .col-xs-1by8 {
    width: 12.5%;
  }

  .col-xs-2by8 {
    width: 25%;
  }

  .col-xs-3by8 {
    width: 37.5%;
  }

  .col-xs-4by8 {
    width: 50%;
  }

  .col-xs-5by8 {
    width: 62.5%;
  }

  .col-xs-6by8 {
    width: 75%;
  }

  .col-xs-7by8 {
    width: 87.5%;
  }

  .col-xs-8by8 {
    width: 100%;
  }

  .img-bulb {
    width: 100%;
  }
}

@media (min-width: 768px) {
  .font-size-sm-9 {
    font-size: 0.9rem;
  }

  .col-sm-1by8 {
    width: 12.5%;
  }

  .col-sm-2by8 {
    width: 25%;
  }

  .col-sm-3by8 {
    width: 37.5%;
  }

  .col-sm-4by8 {
    width: 50%;
  }

  .col-sm-5by8 {
    width: 62.5%;
  }

  .col-sm-6by8 {
    width: 75%;
  }

  .col-sm-7by8 {
    width: 87.5%;
  }

  .col-sm-8by8 {
    width: 100%;
  }

  .btn-viskase {
    min-height: 4.5rem;
  }

  .btn-viskase-orange {
    font-size: 1.2rem;
  }

  .btn-viskase-white {
    font-size: 1.2rem;
  }

  .btn-viskase {
    font-size: 1.2rem;
  }

  .col-xs-1by5,
  .col-xs-2by5,
  .col-xs-3by5,
  .col-xs-4by5,
  .col-xs-5by5,
  .col-1by5,
  .col-2by5,
  .col-3by5,
  .col-4by5,
  .col-5by5,
  .col-1,
  .col-2,
  .col-3,
  .col-4,
  .col-5,
  .col-6,
  .col-7,
  .col-8,
  .col-9,
  .col-10,
  .col-11,
  .col-12,
  .col {
    //font-size: 0.9rem;
    padding: 1px;
  }
}

@media (min-width: 992px) {
  .col-md-1by5,
  .col-md-2by5,
  .col-md-3by5,
  .col-md-4by5,
  .col-md-5by5 {
    width: 20%;
  }
}

@media (min-width: 1200px) {
  .col-xs-1by5,
  .col-xs-2by5,
  .col-xs-3by5,
  .col-xs-4by5,
  .col-xs-5by5,
  .col-1by5,
  .col-2by5,
  .col-3by5,
  .col-4by5,
  .col-5by5,
  .col-1,
  .col-2,
  .col-3,
  .col-4,
  .col-5,
  .col-6,
  .col-7,
  .col-8,
  .col-9,
  .col-10,
  .col-11,
  .col-12,
  .col {
    font-size: 1.1rem;
  }
}

.tip-bulb {
  background-color: #a0273b;
  color: #faf5f5;
}

.tip {
  background-color: #a0273b;
  color: #faf5f5;
}

.viskase-orange-text {
  color: #a0273b;
}

@media (min-width: 0px) {
  .viskase-to-top {
    display: inline-block;
    background-color: #a0273b;
    width: 50px;
    height: 50px;
    text-align: center;
    border-radius: 24px;
    border-color: #faf5f5;
    position: fixed;
    bottom: 90px;
    right: 5px;
    transition: background-color 0.3s, opacity 0.5s, visibility 0.5s;
    opacity: 0;
    visibility: hidden;
    z-index: 1000;
    border-style: solid;
  }
}

@media (min-width: 767px) {
  .viskase-to-top {
    display: inline-block;
    background-color: #a0273b;
    width: 50px;
    height: 50px;
    text-align: center;
    border-radius: 24px;
    border-color: #faf5f5;
    position: fixed;
    bottom: 110px;
    right: 30px;
    transition: background-color 0.3s, opacity 0.5s, visibility 0.5s;
    opacity: 0;
    visibility: hidden;
    z-index: 1000;
    border-style: solid;
  }
}

.viskase-to-top::after {
  //content: "\F286";
  //font-family: FontAwesome;
  font-weight: normal;
  font-style: normal;
  font-size: 2em;
  line-height: 50px;
  color: #fff;
}

.viskase-to-top:hover {
  cursor: pointer;
}

.viskase-to-top:active {
  background-color: #555;
}

.viskase-to-top.show {
  opacity: 1;
  visibility: visible;
}

.form-check-input:checked {
  background-color: #a0273b;
  border-color: #a0273b;
}
</style>
